'use strict';

import $ from 'jquery';
import 'jquery-mask-plugin';
import Swal from 'sweetalert2';
import { modal } from '../modules/modal';

const common = {
  settings: {
    $selectSuper: $('.js-superintendent'),
    $selectRegional: $('.js-regional'),
    gtmCategory: 'voluntariado-santander',
  },
  isIE() {
    const ua = navigator.userAgent;
    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;
  },
  init() {
    modal();

    if (_this.isIE()) {
      Swal.fire(
        'Atenção!',
        'Sugerimos que utilize navegadores como chrome, microsoft edge, firefox, safari ou outro de sua preferência.',
        ''
      );
    }

    if (typeof localStorage.policyCookies == 'undefined' || localStorage.policyCookies == '0') {
      localStorage.policyCookies = '0';
      document.body.classList.add('show-policy');
    } else {
      let expire = new Date(localStorage.policyCookiesExpire),
        today = new Date();

      if (today >= expire) {
        localStorage.policyCookies = 0;
        document.body.classList.add('show-policy');
      }
    }

    // document.querySelector('.js-btn-cookies').addEventListener('click', e => {
    //   e.preventDefault();
    //   let date = new Date(new Date().setDate(new Date().getDate() + 30));
    //   localStorage.policyCookies = '1';
    //   localStorage.policyCookiesExpire = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    //   document.body.classList.remove('show-policy');
    // });

    const $modalTrigger = document.getElementById('modal-trigger');

    if ($modalTrigger) {
      const title = $modalTrigger.getAttribute('data-title'),
        type = $modalTrigger.getAttribute('data-type'),
        text = $modalTrigger.getAttribute('data-text');

      Swal.fire({ title: `${title ? title : ''}`, text: `${text ? text : ''}`, icon: `${type ? type : ''}` });
    }

    $('.js-gtm').on('click', function () {
      var title = $(this).attr('data-title');
      var action = $(this).attr('data-action');

      dataLayer = dataLayer || [];
      dataLayer.push({
        event: 'interaction',
        target: s.gtmCategory,
        action: action,
        'target-properties': title,
      });
    });

    $('.js-gtm-input').on('blur', function () {
      if (this.value.length > 0) {
        var title = $(this).attr('data-title');
        var action = $(this).attr('data-action');

        dataLayer = dataLayer || [];
        dataLayer.push({
          event: 'interaction',
          target: s.gtmCategory,
          action: action,
          'target-properties': title,
        });
      }
    });

    //Toggle Menu
    document.querySelector('.js-toggle-menu').addEventListener('click', e => {
      e.preventDefault();
      document.body.classList.toggle('nav-active');
    });

    $(document).on('click', '.js-delete', function (e) {
      e.preventDefault();
      let data_id = $(this).attr('data-id');

      Swal.fire({
        title: 'Excluir registro?',
        text: 'Tem certeza que deseja remover este registro?',
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'o-btn o-btn--brand',
          cancelButton: 'o-btn o-btn--secondary',
        },
        confirmButtonText: 'Sim, excluir registro!',
        cancelButtonText: 'Não excluir',
      }).then(result => {
        if (result.value) {
          var token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            headers: {
              'X-CSRF-TOKEN': token,
            },
            url: $(this).attr('data-url'),
            method: 'DELETE',
            success: function (data) {
              Swal.fire({
                title: data.title,
                text: data.message,
                icon: data.type,
                customClass: {
                  confirmButton: 'o-btn o-btn--brand',
                  cancelButton: 'o-btn o-btn--secondary',
                },
              });

              var row = document.getElementById(data_id);
              row.parentNode.removeChild(row);

              if (data.count) {
                var row = document.getElementById(data_id);
                row.parentNode.removeChild(row);
                $('#counter').html(data.count);
              }
            },
          });
        }
      });
    });

    $(document).on('click', '.js-delete-custom', function (e) {
      e.preventDefault();
      let data_id = $(this).attr('data-id');
      let data_title = $(this).attr('data-message-title');
      let data_content = $(this).attr('data-message-content');

      Swal.fire({
        title: data_title,
        text: data_content,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Não excluir',
      }).then(result => {
        if (result.value) {
          var token = $('meta[name="csrf-token"]').attr('content');

          $.ajax({
            headers: {
              'X-CSRF-TOKEN': token,
            },
            url: $(this).attr('data-url'),
            method: 'DELETE',
            success: function (data) {
              Swal.fire({
                title: data.title,
                text: data.message,
                icon: data.type,
                customClass: {
                  confirmButton: 'o-btn o-btn--brand',
                  cancelButton: 'o-btn o-btn--secondary',
                },
              });

              if (data.type == 'success') {
                var row = document.getElementById(data_id);
                row.parentNode.removeChild(row);

                if (data.count) {
                  $('.js-counter').html(data.count);
                }
              }
            },
          });
        }
      });
    });

    const maskEl = {
      $cnpj: [$('.js-form-cnpj'), '99.999.999/9999-99'],
      $cpf: [$('.js-form-cpf'), '999.999.999-99', { clearIfNotMatch: true }],
      $enrollment: [$('.js-form-enrollment'), '000000', { clearIfNotMatch: true }],
      $date: [$('.js-form-date'), '99/99/9999'],
      $hour: [$('.js-form-hour'), '00:00'],
      $ddd: [$('.js-form-ddd'), '(99)'],
      $phone: [$('.js-form-phone'), '(99) 99999.9999'],
      $comercialPhone: [$('.js-form-phone-commercial'), '(99) 9999.9999'],
      $number: [$('.js-number'), '999999999999'],
    };

    Object.keys(maskEl).forEach(el => {
      if (maskEl[el][0].length > 0) {
        maskEl[el][0].mask(maskEl[el][1], maskEl[el][2] ? maskEl[el][2] : {});
        if (typeof maskEl[el][0].attr('value') !== 'undefined') {
          if (maskEl[el][0].attr('value').length <= 0) {
            setTimeout(() => {
              maskEl[el][0].val('');
            }, 600);
          }
        }
      }
    });

    // Email Protective SPAM Solution
    const $mailContainer = document.querySelectorAll('[data-mail-creator]');

    if ($mailContainer.length) {
      $mailContainer.forEach(el => {
        let $mail = document.createElement('a');
        let arrMail = el.getAttribute('data-mail-creator').split(',');

        if (arrMail.length == 3) {
          let label =
            arrMail[0].replace(/\s/g, '') + '@' + arrMail[1].replace(/\s/g, '') + arrMail[2].replace(/\s/g, '');
          $mail.setAttribute('href', 'ma' + 'il' + 'to:' + label);
          $mail.textContent = label;
          el.appendChild($mail);
        }
      });
    }

    $('.file-input').change(function () {
      $('#label_' + this.name).text(this.files[0].name);
    });

    s.$selectSuper.on('change', function (e) {
      e.preventDefault();

      var post = {};

      s.$selectRegional.empty();
      s.$selectRegional.append($('<option></option>').attr('value', '').text('Carregando...'));

      post.id = s.$selectSuper.val();
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/busca-regionais/' + post.id;

      $.ajax({
        type: 'GET',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
        success: function (data) {
          if (data) {
            s.$selectRegional.empty();

            s.$selectRegional.append($('<option></option>').attr('value', '0').text('Selecione sua regional'));
            $.each(data, function (index, element) {
              s.$selectRegional.append($('<option></option>').attr('value', index).text(element));
            });
          }
        },
      });
    });

    $(document).on('mouseover', '.c-popover--open', function (e) {
      e.preventDefault();
      $('#' + $(this).attr('data-id')).addClass('c-popover--open');
    });

    $(document).on('mouseout', '.c-popover--open', function (e) {
      e.preventDefault();
      $('#' + $(this).attr('data-id')).removeClass('c-popover--open');
    });

    $('.js-modal-warning-logged').on('click', function (e) {
      e.preventDefault();
      Swal.fire({
        html:
          '<h3 class="o-ttl">' +
          $(this).attr('data-title') +
          '</h3>' +
          '<p>Você precisa realizar o seu login na plataforma para visualizar essas informações.</p>',
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });

    const $customCheck = $('[data-custom-check]');

    $customCheck.on('click', function (e) {
      const $check = $(this).find('input[type="checkbox"]');

      let $status = 0;

      if ($($check).is(':checked')) {
        $check.prop('checked', false);
      } else {
        $check.prop('checked', true);
        $status = 1;
      }

      let url = $(this).attr('data-url');
      var post = {};
      post.receive_notifications = $status;
      post._token = $('meta[name="csrf-token"]').attr('content');

      $.ajax({
        type: 'POST',
        url: url,
        data: post,
        cache: false,
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            Swal.fire(data.title, data.message, data.type);
          }
        },
      });
    });

    $(document).on('click', '.js-send-email', function (e) {
      e.preventDefault();
      $('#tab-send-email').removeClass('u-display--none');
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('action') == 'mail') {
      $('#tab-send-email').removeClass('u-display--none');
    }

    $(document).on('click', '.js-cancel-email', function (e) {
      e.preventDefault();

      $('#tab-send-email').addClass('u-display--none');
    });
  },
};

const s = common.settings,
  _this = common;

export default _this;
